import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../constants';
import Button from './ui/button';
import ContactForm from './forms/ContactForm';


const LetsTalk = () => {
  return (
    <section
      className="py-8 sm:py-12 lg:py-16 px-4 sm:px-8 md:px-16 lg:px-24"
      style={{ backgroundColor: COLORS.secondary }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Left Column - Let's talk */}
          <div className="text-white max-w-md">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-tight mb-6 sm:mb-8">
              Let's <span style={{ color: '#db0058' }}>talk...</span>
            </h1>
            <div className="space-y-3 sm:space-y-4 text-base sm:text-lg">
              <p>So you're ready to get on board?</p>
              <p>
                See how Lloyd James could help <strong>unlock the power of your data and take your business further.</strong>
              </p>
            </div>
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium" className="mt-6 sm:mt-8">
                Contact us
              </Button>
            </Link>
          </div>

          {/* Right Column - Enquire now form */}
          <ContactForm
            title="Enquire now"
            webFormId="lloyd_james_lets_talk_form"
          />
        </div>
      </div>

    </section>
  );
};

export default LetsTalk;